<div fxLayout>
  <main [ngClass.lt-md]="{ mobile: true }" *ngIf="!loading">
    <header>
      <div class="container">
        <app-feature-flag-tabs>
          <sbnb-page-header navTabs [parentPath]="'support-documentation'"></sbnb-page-header>

          <a class="back-link" [routerLink]="['/support-documentation']">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.62573 8.99774H12.3757"
                stroke="#ED3C6A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M8.43823 11.8102L5.62573 8.99774L8.43823 6.18524"
                stroke="#ED3C6A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M9.00073 16.8727C13.35 16.8727 16.8757 13.347 16.8757 8.99774C16.8757 4.6485 13.35 1.12274 9.00073 1.12274C4.65149 1.12274 1.12573 4.6485 1.12573 8.99774C1.12573 13.347 4.65149 16.8727 9.00073 16.8727Z"
                stroke="#ED3C6A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <div>Support documentation</div>
          </a>
        </app-feature-flag-tabs>
        <div class="header-wrapper">
          <div class="header-content">
            <div class="header-title">
              <div class="icon">
                <sbnb-support-documentation-icon [icon]="category.icon"></sbnb-support-documentation-icon>
              </div>
              <h2>{{ category.name }}</h2>
            </div>
            <div class="header-description">{{ category.description }}</div>
          </div>
          <a [routerLink]="['/support-documentation/search']" class="header-search">
            <sbnb-search-field></sbnb-search-field>
          </a>
        </div>
      </div>
    </header>
    <div class="container">
      <section *ngIf="category.videos && category.videos.length > 0">
        <sbnb-video-card-grid [videos]="category.videos"></sbnb-video-card-grid>
      </section>
      <section *ngFor="let section of category.sections">
        <sbnb-article-list
          [id]="section.slug"
          [title]="section.name"
          [articles]="section.articles"
          columns="2"></sbnb-article-list>
      </section>
    </div>
  </main>
</div>
